// src/pages/abonnements/NouvelAbonnement.jsx
import React, { useState, useEffect } from 'react';
import { Row, Col, Card, Form, Button, Alert, Spinner } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import Header from '../../layouts/Header';
import Footer from '../../layouts/Footer';
import { COLORS } from '../../constants/colors';

// ===== STYLES =====
const styles = `
  .dashboard-styled {
    background: #f4f6f9;
    min-height: 100vh;
  }

  /* En-tête moderne */
  .header-modern {
    background: white;
    padding: 1.2rem 1.8rem;
    box-shadow: 0 2px 8px rgba(0,0,0,0.04);
    border-left: 4px solid ${COLORS.secondary};
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .header-left {
    display: flex;
    align-items: center;
    gap: 1rem;
  }

  .header-icon-wrapper {
    width: 48px;
    height: 48px;
    background: ${COLORS.primary};
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    color: white;
    font-size: 1.4rem;
  }

  .gradient-text {
    color: #1e293b;
    font-size: 1.3rem;
    font-weight: 700;
    margin: 0;
  }

  .badge-modern {
    background: #f1f4f9;
    color: #475569;
    padding: 0.3rem 0.8rem;
    border-radius: 4px;
    font-size: 0.75rem;
    font-weight: 600;
    display: inline-flex;
    align-items: center;
    gap: 6px;
  }
  .badge-modern i {
    color: ${COLORS.secondary};
  }

  .btn-modern-outline {
    border: 1px solid #d1d5db;
    background: white;
    padding: 0.4rem 1.2rem;
    border-radius: 4px;
    font-size: 0.85rem;
    font-weight: 500;
    color: #4b5563;
    transition: all 0.2s;
    display: inline-flex;
    align-items: center;
    gap: 6px;
  }
  .btn-modern-outline:hover {
    border-color: ${COLORS.secondary};
    color: ${COLORS.secondary};
    background: #fafafa;
  }

  .btn-modern-primary {
    background: ${COLORS.primary};
    border: none;
    padding: 0.4rem 1.2rem;
    border-radius: 4px;
    font-size: 0.85rem;
    font-weight: 500;
    color: white;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    transition: all 0.2s;
  }
  .btn-modern-primary:hover {
    background: ${COLORS.primaryDark};
    box-shadow: 0 4px 10px rgba(41,90,167,0.3);
  }

  /* Card */
  .card-modern {
    border: none;
    border-radius: 4px;
    background: white;
    box-shadow: 0 2px 6px rgba(0,0,0,0.04);
    border-top: 3px solid transparent;
    transition: box-shadow 0.2s;
  }
  .card-modern:hover {
    box-shadow: 0 4px 12px rgba(0,0,0,0.06);
  }
  .card-modern.border-primary {
    border-top-color: ${COLORS.primary};
  }

  .card-header-modern {
    background: transparent;
    border-bottom: 1px solid #e9edf2;
    padding: 0.8rem 1.2rem;
    font-weight: 600;
    color: #1e293b;
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }
  .card-header-modern i {
    color: ${COLORS.secondary};
  }

  .card-body-modern {
    padding: 1.5rem;
  }

  /* Form */
  .form-label-modern {
    font-size: 0.7rem;
    font-weight: 600;
    color: #475569;
    margin-bottom: 0.2rem;
  }
  .form-label-modern .required {
    color: ${COLORS.danger};
    margin-left: 2px;
  }

  .form-control-modern, .form-select-modern {
    border: 1px solid #e2e8f0;
    border-radius: 4px;
    padding: 0.4rem 0.7rem;
    font-size: 0.85rem;
    transition: all 0.2s ease;
    background: white;
  }
  .form-control-modern:focus, .form-select-modern:focus {
    border-color: ${COLORS.primary};
    box-shadow: 0 0 0 3px rgba(41,90,167,0.08);
  }
  .form-control-modern.is-invalid, .form-select-modern.is-invalid {
    border-color: ${COLORS.danger};
  }
  .form-control-modern.is-invalid:focus, .form-select-modern.is-invalid:focus {
    box-shadow: 0 0 0 3px rgba(239,68,68,0.08);
  }

  .form-text-modern {
    font-size: 0.7rem;
    color: #94a3b8;
    margin-top: 0.2rem;
  }

  /* Notifications */
  .toast-notification {
    padding: 0.8rem 1rem;
    border: none;
    display: flex;
    align-items: flex-start;
    gap: 10px;
    margin-bottom: 1.5rem;
    animation: slideDown 0.3s ease-out;
    border-radius: 4px;
  }
  .toast-notification-success {
    background: #f0fdf4;
    border-left: 3px solid ${COLORS.success};
  }
  .toast-notification-error {
    background: #fef2f2;
    border-left: 3px solid ${COLORS.danger};
  }
  .toast-icon {
    width: 28px;
    height: 28px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    font-size: 1rem;
  }
  .toast-icon-success {
    background: rgba(16,185,129,0.15);
    color: ${COLORS.success};
  }
  .toast-icon-error {
    background: rgba(239,68,68,0.15);
    color: ${COLORS.danger};
  }
  .toast-content {
    flex: 1;
  }
  .toast-title {
    font-size: 0.8rem;
    font-weight: 600;
    margin-bottom: 1px;
  }
  .toast-message {
    font-size: 0.75rem;
    color: #64748b;
    margin: 0;
  }
  .toast-close {
    background: none;
    border: none;
    color: #94a3b8;
    cursor: pointer;
    padding: 2px;
    font-size: 1rem;
  }

  /* Loading */
  .loading-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 60vh;
  }
  .loading-ring-wrapper {
    position: relative;
    width: 70px;
    height: 70px;
  }
  .loading-ring {
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    border: 3px solid #e9edf2;
    border-top-color: ${COLORS.primary};
    animation: spin 0.8s linear infinite;
  }
  .loading-ring-inner {
    position: absolute;
    top: 8px;
    left: 8px;
    right: 8px;
    bottom: 8px;
    border-radius: 50%;
    border: 2px solid #e9edf2;
    border-bottom-color: ${COLORS.secondary};
    animation: spin 0.6s linear infinite reverse;
  }
  @keyframes spin { to { transform: rotate(360deg); } }

  /* Animations */
  @keyframes slideDown {
    from { opacity: 0; transform: translateY(-8px); }
    to { opacity: 1; transform: translateY(0); }
  }
  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(6px); }
    to { opacity: 1; transform: translateY(0); }
  }
  .fade-in {
    animation: fadeIn 0.3s ease-out;
  }

  @media (max-width: 768px) {
    .header-modern {
      flex-direction: column;
      align-items: stretch;
      gap: 0.8rem;
      padding: 1rem;
    }
    .header-left {
      flex-wrap: wrap;
    }
    .card-body-modern {
      padding: 1rem;
    }
  }
`;

export default function NouvelAbonnement() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [eglises, setEglises] = useState([]);

  const [formData, setFormData] = useState({
    matri_abon: '',
    matri_eglise: '',
    date_deb: new Date().toISOString().split('T')[0],
    date_fin: '',
    montant: '',
    description: ''
  });

  const [validationErrors, setValidationErrors] = useState({});
  const [dateInfo, setDateInfo] = useState({
    duree: 0,
    montantParJour: 0
  });

  // Calcul de la durée et du montant par jour
  useEffect(() => {
    if (formData.date_deb && formData.date_fin && formData.montant) {
      const debut = new Date(formData.date_deb);
      const fin = new Date(formData.date_fin);
      const diffTime = Math.abs(fin - debut);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      setDateInfo({
        duree: diffDays,
        montantParJour: parseFloat(formData.montant) / diffDays || 0
      });
    }
  }, [formData.date_deb, formData.date_fin, formData.montant]);

  useEffect(() => {
    const fetchEglises = async () => {
      try {
        setLoading(true);
        const userStr = localStorage.getItem('user');
        if (!userStr) {
          navigate('/pages/signin2');
          return;
        }

        const user = JSON.parse(userStr);
        const userId = user.id || user.id_utilisateur;

        const response = await fetch(`https://josephsbusiness.com/api/eglises.php?user_id=${userId}&type=siege&limit=1000`);
        const result = await response.json();

        if (result.success) {
          setEglises(result.eglises || []);
        }

        if (id) {
          const abonRes = await fetch(`https://josephsbusiness.com/api/abonnements.php?user_id=${userId}&id=${id}`);
          const abonData = await abonRes.json();
          if (abonData.success && abonData.abonnement) {
            const abon = abonData.abonnement;
            setFormData({
              matri_abon: abon.matri_abon,
              matri_eglise: abon.matri_eglise,
              date_deb: abon.date_deb,
              date_fin: abon.date_fin,
              montant: abon.montant,
              description: abon.description || ''
            });
          }
        }
      } catch (err) {
        setError('Erreur de chargement: ' + err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchEglises();
  }, [id, navigate]);

  const validateForm = () => {
    const errors = {};
    if (!formData.matri_eglise) errors.matri_eglise = "L'église est requise";
    if (!formData.date_deb) errors.date_deb = 'La date de début est requise';
    if (!formData.date_fin) errors.date_fin = 'La date de fin est requise';
    if (!formData.montant) errors.montant = 'Le montant est requis';
    else if (isNaN(formData.montant) || parseFloat(formData.montant) <= 0) {
      errors.montant = 'Le montant doit être un nombre positif';
    }

    if (formData.date_deb && formData.date_fin) {
      const dateDeb = new Date(formData.date_deb);
      const dateFin = new Date(formData.date_fin);
      if (dateFin <= dateDeb) {
        errors.date_fin = 'La date de fin doit être après la date de début';
      }
    }

    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    if (validationErrors[name]) {
      setValidationErrors(prev => ({ ...prev, [name]: null }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    setSaving(true);
    setError(null);

    try {
      const userStr = localStorage.getItem('user');
      const user = JSON.parse(userStr);
      const userId = user.id || user.id_utilisateur;

      let matri_abon = formData.matri_abon;
      if (!id) {
        const date = new Date();
        const annee = date.getFullYear();
        const mois = (date.getMonth() + 1).toString().padStart(2, '0');
        const random = Math.floor(Math.random() * 1000).toString().padStart(3, '0');
        matri_abon = `ABON${annee}${mois}${random}`;
      }

      const url = `https://josephsbusiness.com/api/abonnements.php?user_id=${userId}`;
      const method = id ? 'PUT' : 'POST';

      const response = await fetch(url, {
        method: method,
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          ...formData,
          id_abon: id,
          matri_abon: matri_abon,
          montant: parseFloat(formData.montant)
        })
      });

      const result = await response.json();

      if (result.success) {
        setSuccess(true);
        setTimeout(() => {
          navigate('/abonnements/liste?reload=1');
        }, 2000);
      } else {
        setError(result.message || 'Erreur lors de l\'enregistrement');
      }
    } catch (err) {
      setError('Erreur: ' + err.message);
    } finally {
      setSaving(false);
    }
  };

  const getEgliseInfo = (matricule) => {
    const eglise = eglises.find(e => e.matricule === matricule);
    return eglise || null;
  };

  const formatMontant = (montant) => {
    return new Intl.NumberFormat('fr-FR').format(montant) + ' FCFA';
  };

  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString('fr-FR', options);
  };

if (loading) {
  return (
    <>
      <Header />
      <div
        className="main main-app p-3 p-lg-4"
        style={{
          background: 'linear-gradient(135deg, #f8fafc 0%, #eef2f6 100%)',
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <div className="text-center" style={{ maxWidth: '420px', padding: '2rem' }}>
          {/* Icône animée */}
          <div className="loading-logo-wrapper mb-4">
            <div className="loading-logo-pulse">
              <div className="loading-logo-circle">
                <i className="ri-calendar-check-line" style={{ fontSize: '2.5rem', color: COLORS.primary }}></i>
              </div>
            </div>
          </div>

          {/* Titre avec points de suspension animés */}
          <h5 className="fw-bold mb-2" style={{ color: COLORS.primaryDark }}>
            Chargement en cours
            <span className="loading-dots">
              <span>.</span><span>.</span><span>.</span>
            </span>
          </h5>
          <p className="text-muted small mb-4">Préparation du formulaire, veuillez patienter...</p>

          {/* Barre de progression animée */}
          <div className="loading-progress-wrapper mx-auto" style={{ width: '80%' }}>
            <div
              className="loading-progress-track"
              style={{
                height: '4px',
                borderRadius: '4px',
                background: '#e9edf2',
                overflow: 'hidden',
                position: 'relative'
              }}
            >
              <div
                className="loading-progress-bar"
                style={{
                  height: '100%',
                  width: '0%',
                  background: `linear-gradient(90deg, ${COLORS.primary}, ${COLORS.secondary}, ${COLORS.primary})`,
                  backgroundSize: '200% 100%',
                  borderRadius: '4px',
                  animation: 'loadingProgress 2s ease-in-out infinite, shimmer 1.5s linear infinite'
                }}
              />
            </div>
          </div>

          {/* Badge de statut */}
          <div className="mt-3">
            <span
              className="badge"
              style={{
                background: `${COLORS.primary}10`,
                color: COLORS.primary,
                borderRadius: '4px',
                padding: '0.3rem 1rem',
                fontSize: '0.7rem',
                fontWeight: '500',
                border: `1px solid ${COLORS.primary}20`
              }}
            >
              <i className="ri-loader-4-line me-1" style={{ animation: 'spin 1s linear infinite' }}></i>
              Préparation...
            </span>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes spin {
          to { transform: rotate(360deg); }
        }

        @keyframes loadingProgress {
          0% { width: 0%; }
          50% { width: 70%; }
          100% { width: 100%; }
        }

        @keyframes shimmer {
          0% { background-position: 200% 0; }
          100% { background-position: -200% 0; }
        }

        @keyframes pulseGlow {
          0%, 100% {
            transform: scale(1);
            opacity: 0.8;
          }
          50% {
            transform: scale(1.1);
            opacity: 1;
          }
        }

        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-8px); }
        }

        .loading-logo-wrapper {
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .loading-logo-pulse {
          animation: pulseGlow 1.8s ease-in-out infinite;
        }

        .loading-logo-circle {
          width: 80px;
          height: 80px;
          border-radius: 50%;
          background: white;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 8px 32px rgba(41, 90, 167, 0.12);
          border: 2px solid ${COLORS.primary}20;
          animation: float 2.5s ease-in-out infinite;
          position: relative;
        }

        .loading-logo-circle::after {
          content: '';
          position: absolute;
          top: -3px;
          left: -3px;
          right: -3px;
          bottom: -3px;
          border-radius: 50%;
          border: 2px solid transparent;
          border-top-color: ${COLORS.primary};
          border-right-color: ${COLORS.secondary};
          animation: spin 1.2s linear infinite;
        }

        .loading-dots span {
          display: inline-block;
          animation: bounce 1.4s ease-in-out infinite;
          font-size: 1.6rem;
          line-height: 1;
          margin-left: 1px;
        }
        .loading-dots span:nth-child(1) { animation-delay: 0s; }
        .loading-dots span:nth-child(2) { animation-delay: 0.2s; }
        .loading-dots span:nth-child(3) { animation-delay: 0.4s; }

        @keyframes bounce {
          0%, 80%, 100% { transform: scale(1); opacity: 0.3; }
          40% { transform: scale(1.2); opacity: 1; }
        }

        .loading-progress-track {
          box-shadow: inset 0 1px 3px rgba(0,0,0,0.05);
        }
      `}</style>

      <Footer />
    </>
  );
}

  return (
    <>
      <style>{styles}</style>
      <Header />
      <div className="main main-app p-3 p-lg-4 dashboard-styled">
        <div className="container-fluid px-0">

          {/* ===== EN‑TÊTE MODERNE ===== */}
          <div className="header-modern mb-4 fade-in">
            <div className="header-left">
              <div className="header-icon-wrapper">
                <i className={id ? "ri-edit-line" : "ri-add-line"}></i>
              </div>
              <div>
                <h5 className="gradient-text">
                  {id ? 'Modifier un abonnement' : 'Nouvel abonnement'}
                </h5>
                <div className="d-flex flex-wrap gap-2">
                  <span className="badge-modern">
                    <i className="ri-information-line"></i>
                    {id ? 'Modification' : 'Création'}
                  </span>
                  <span className="badge-modern">
                    <i className="ri-calendar-line"></i>
                    {new Date().toLocaleDateString('fr-FR')}
                  </span>
                </div>
              </div>
            </div>
            <div className="d-flex gap-2">
              <Button size="sm" className="btn-modern-outline" onClick={() => navigate('/abonnements/liste')}>
                <i className="ri-arrow-left-line"></i> Retour
              </Button>
            </div>
          </div>

          {/* ===== NOTIFICATIONS ===== */}
          {error && (
            <div className="toast-notification toast-notification-error mb-4">
              <div className="toast-icon toast-icon-error">
                <i className="ri-error-warning-line"></i>
              </div>
              <div className="toast-content">
                <div className="toast-title" style={{ color: COLORS.danger }}>Erreur</div>
                <p className="toast-message">{error}</p>
              </div>
              <button className="toast-close" onClick={() => setError(null)}>
                <i className="ri-close-line"></i>
              </button>
            </div>
          )}

          {success && (
            <div className="toast-notification toast-notification-success mb-4">
              <div className="toast-icon toast-icon-success">
                <i className="ri-checkbox-circle-line"></i>
              </div>
              <div className="toast-content">
                <div className="toast-title" style={{ color: COLORS.success }}>Succès</div>
                <p className="toast-message">Abonnement enregistré avec succès. Redirection...</p>
              </div>
              <button className="toast-close" onClick={() => setSuccess(false)}>
                <i className="ri-close-line"></i>
              </button>
            </div>
          )}

          {/* ===== CARD PRINCIPALE ===== */}
          <Row className="justify-content-center">
            <Col lg={8}>
              <Card className="card-modern border-primary">
                <Card.Header className="card-header-modern">
                  <i className="ri-information-line"></i> Informations de l'abonnement
                </Card.Header>
                <Card.Body className="card-body-modern">
                  <Form onSubmit={handleSubmit}>
                    {/* Église */}
                    <Form.Group className="mb-3">
                      <Form.Label className="form-label-modern">
                        <i className="ri-building-line me-1"></i> Église <span className="required">*</span>
                      </Form.Label>
                      <Form.Select
                        name="matri_eglise"
                        value={formData.matri_eglise}
                        onChange={handleInputChange}
                        isInvalid={!!validationErrors.matri_eglise}
                        className="form-select-modern"
                      >
                        <option value="">Sélectionnez une église</option>
                        {eglises.map(eglise => (
                          <option key={eglise.matricule} value={eglise.matricule}>
                            {eglise.nom} {eglise.ville ? `- ${eglise.ville}` : ''}
                          </option>
                        ))}
                      </Form.Select>
                      {validationErrors.matri_eglise && (
                        <Form.Control.Feedback type="invalid" style={{ display: 'block' }}>
                          {validationErrors.matri_eglise}
                        </Form.Control.Feedback>
                      )}
                      {formData.matri_eglise && (
                        <div className="form-text-modern mt-1">
                          <i className="ri-map-pin-line me-1"></i>
                          {getEgliseInfo(formData.matri_eglise)?.ville || 'Ville non spécifiée'}
                          <span className="mx-2">•</span>
                          <i className="ri-phone-line me-1"></i>
                          {getEgliseInfo(formData.matri_eglise)?.tel || 'Tél. non disponible'}
                        </div>
                      )}
                    </Form.Group>

                    {/* Dates */}
                    <Row className="mb-3">
                      <Col md={6}>
                        <Form.Group>
                          <Form.Label className="form-label-modern">
                            <i className="ri-calendar-line me-1"></i> Date de début <span className="required">*</span>
                          </Form.Label>
                          <Form.Control
                            type="date"
                            name="date_deb"
                            value={formData.date_deb}
                            onChange={handleInputChange}
                            isInvalid={!!validationErrors.date_deb}
                            className="form-control-modern"
                          />
                          {validationErrors.date_deb && (
                            <Form.Control.Feedback type="invalid" style={{ display: 'block' }}>
                              {validationErrors.date_deb}
                            </Form.Control.Feedback>
                          )}
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group>
                          <Form.Label className="form-label-modern">
                            <i className="ri-calendar-line me-1"></i> Date de fin <span className="required">*</span>
                          </Form.Label>
                          <Form.Control
                            type="date"
                            name="date_fin"
                            value={formData.date_fin}
                            onChange={handleInputChange}
                            isInvalid={!!validationErrors.date_fin}
                            className="form-control-modern"
                          />
                          {validationErrors.date_fin && (
                            <Form.Control.Feedback type="invalid" style={{ display: 'block' }}>
                              {validationErrors.date_fin}
                            </Form.Control.Feedback>
                          )}
                        </Form.Group>
                      </Col>
                    </Row>

                    {/* Informations sur la durée */}
                    {formData.date_deb && formData.date_fin && dateInfo.duree > 0 && (
                      <div className="mb-4 p-3" style={{
                        background: `${COLORS.primary}08`,
                        borderRadius: '4px',
                        border: `1px solid ${COLORS.primary}20`
                      }}>
                        <Row className="g-3 text-center">
                          <Col md={4}>
                            <div className="small text-muted">Durée</div>
                            <div className="h5 fw-bold" style={{ color: COLORS.primary }}>
                              {dateInfo.duree} jour{dateInfo.duree > 1 ? 's' : ''}
                            </div>
                          </Col>
                          <Col md={4}>
                            <div className="small text-muted">Mois</div>
                            <div className="h5 fw-bold" style={{ color: COLORS.secondary }}>
                              {(dateInfo.duree / 30).toFixed(1)} mois
                            </div>
                          </Col>
                          <Col md={4}>
                            <div className="small text-muted">Montant/jour</div>
                            <div className="h5 fw-bold" style={{ color: COLORS.success }}>
                              {formatMontant(dateInfo.montantParJour)}
                            </div>
                          </Col>
                        </Row>
                      </div>
                    )}

                    {/* Montant */}
                    <Form.Group className="mb-3">
                      <Form.Label className="form-label-modern">
                        <i className="ri-money-euro-circle-line me-1"></i> Montant <span className="required">*</span>
                      </Form.Label>
                      <div className="position-relative">
                        <Form.Control
                          type="number"
                          name="montant"
                          value={formData.montant}
                          onChange={handleInputChange}
                          placeholder="Ex: 50000"
                          isInvalid={!!validationErrors.montant}
                          className="form-control-modern"
                          style={{ paddingLeft: '3rem' }}
                        />
                        <span style={{
                          position: 'absolute',
                          left: '0.7rem',
                          top: '50%',
                          transform: 'translateY(-50%)',
                          color: COLORS.primary,
                          fontWeight: '600',
                          fontSize: '0.85rem'
                        }}>
                          FCFA
                        </span>
                      </div>
                      {validationErrors.montant && (
                        <Form.Control.Feedback type="invalid" style={{ display: 'block' }}>
                          {validationErrors.montant}
                        </Form.Control.Feedback>
                      )}
                      <Form.Text className="form-text-modern">
                        Montant total de l'abonnement en Francs CFA
                      </Form.Text>
                    </Form.Group>

                    {/* Description */}
                    <Form.Group className="mb-3">
                      <Form.Label className="form-label-modern">
                        <i className="ri-file-text-line me-1"></i> Description (optionnelle)
                      </Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={4}
                        name="description"
                        value={formData.description}
                        onChange={handleInputChange}
                        placeholder="Ajoutez des détails sur cet abonnement..."
                        className="form-control-modern"
                      />
                    </Form.Group>

                    {/* Aperçu / Résumé */}
                    {formData.matri_eglise && formData.date_deb && formData.date_fin && formData.montant && (
                      <div className="mb-4 p-3" style={{
                        background: '#f8fafc',
                        borderRadius: '4px',
                        border: '1px solid #e9edf2'
                      }}>
                        <h6 className="fw-semibold mb-2" style={{ color: COLORS.primary }}>
                          <i className="ri-eye-line me-2"></i> Aperçu
                        </h6>
                        <Row>
                          <Col md={6}>
                            <div className="small text-muted">Église</div>
                            <div className="fw-semibold mb-2">{getEgliseInfo(formData.matri_eglise)?.nom}</div>

                            <div className="small text-muted">Période</div>
                            <div className="fw-semibold mb-2">
                              Du {formatDate(formData.date_deb)}<br />
                              Au {formatDate(formData.date_fin)}
                            </div>
                          </Col>
                          <Col md={6}>
                            <div className="small text-muted">Montant</div>
                            <div className="h5 fw-bold mb-2" style={{ color: COLORS.primary }}>
                              {formatMontant(formData.montant)}
                            </div>

                            <div className="small text-muted">Statut</div>
                            <div>
                              <span className="badge" style={{
                                background: COLORS.secondary,
                                color: '#1e293b',
                                borderRadius: '4px',
                                padding: '0.3rem 1rem',
                                fontWeight: '600'
                              }}>
                                En création
                              </span>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    )}

                    {/* Boutons */}
                    <div className="d-flex justify-content-end gap-3 mt-4">
                      <Button
                        variant="light"
                        onClick={() => navigate('/abonnements/liste')}
                        disabled={saving}
                        className="btn-modern-outline"
                      >
                        <i className="ri-close-line me-1"></i> Annuler
                      </Button>
                      <Button
                        type="submit"
                        disabled={saving}
                        className="btn-modern-primary"
                      >
                        {saving ? (
                          <><Spinner size="sm" className="me-1" /> Enregistrement...</>
                        ) : (
                          <><i className="ri-save-line me-1"></i> {id ? 'Modifier' : 'Enregistrer'}</>
                        )}
                      </Button>
                    </div>
                  </Form>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          <Footer />
        </div>
      </div>
    </>
  );
}